import { AuthActionTypes } from '../store/auth/action-types';
import { trackEvent, trackInteraction } from './UsageTrackingMiddleware';
import { EventName } from './EventName';
import { OAuthActionTypes } from '../store/oauth/action-types';
import { OAuthToIdentityVerificationMethod } from '../oauth/OAuthMapping';
import { OAuthExistingUserErrorMessage } from '../store/oauth/action-creators';
export const oAuthActionHandlers = {
  [OAuthActionTypes.AuthStarted]: action => {
    trackEvent(EventName.VerifyIdentityStarted, {
      verificationMethod: OAuthToIdentityVerificationMethod[action.provider]
    });
  },
  [AuthActionTypes.ExistingOAuthUser]: action => {
    trackInteraction({
      action: `${action.provider}-oauth-signin`
    });
    trackEvent(EventName.VerifyIdentityCompleted, {
      verificationMethod: OAuthToIdentityVerificationMethod[action.provider]
    });
  },
  [OAuthActionTypes.VerificationSucceeded]: action => {
    trackInteraction({
      action: `${action.provider}-oauth-success`
    });
    trackEvent(EventName.VerifyIdentityCompleted, {
      verificationMethod: OAuthToIdentityVerificationMethod[action.provider]
    });
  },
  [OAuthActionTypes.VerificationFailed]: action => {
    const isExistingUser = action.payload.status === OAuthExistingUserErrorMessage;

    if (!isExistingUser) {
      trackInteraction({
        action: `${action.provider}-oauth-error`
      });
    }
  },
  [OAuthActionTypes.AuthFailed]: action => {
    const userCancelledFlow = action.payload && action.payload.errorMessage && action.payload.errorMessage === 'User cancelled the flow.';

    if (userCancelledFlow) {
      trackInteraction({
        action: `${action.provider}-oauth-user-cancel`
      });
    } else {
      trackInteraction({
        action: `${action.provider}-oauth-auth-error`
      });
    }
  },
  [AuthActionTypes.OAuthAuthenticationFailed]: action => {
    trackInteraction({
      action: `${action.provider}-signin-error`
    });
  }
};